/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".commandButton_3bbc318a{font-size:14px}\n"}]);
export const commandButton = "commandButton_3bbc318a";